module.exports = __webpack_public_path__ + "img/image_27.763bf6ad.png";